/* ============================================================================
   dd-event-countdown.js

   Drives every live-event countdown on the in-person certification PDP and
   the announcement-bar event_countdown block. A single ticker updates ALL
   `[data-dd-event-countdown]` mounts on the page — the hero poster, closing
   CTA band, and glass-nav ticker clones share this one script.

   Contract (set by the Liquid that renders the mount):
     [data-dd-event-countdown]            host element
       data-event-target="ISO-8601"       absolute target instant, e.g.
                                           2026-11-08T09:00:00-07:00
       [data-dd-ec-live]                  wrapper around the live tiles
       [data-dd-ec-days]                  number slot (days, un-padded)
       [data-dd-ec-hours]                 number slot (hours, zero-padded)
       [data-dd-ec-minutes]               number slot (minutes, zero-padded)
       [data-dd-ec-seconds]               number slot (seconds, zero-padded)
       [data-dd-ec-expired]               "registration closed / join waitlist"
                                          fallback, rendered `hidden`

   Hard rules honoured:
     • Zero Shopify fetches — pure client clock math (rate-limit-awareness).
     • Singleton guard (window._ddEventCountdownInit) so a re-injected section
       script can't stack a second interval (rate-limit-awareness red flag).
     • prefers-reduced-motion → render ONE static snapshot, no interval, so the
       UI doesn't animate for motion-sensitive users (mobile-touch / a11y).
     • Graceful expiry — when the target passes we hide the live tiles, reveal
       the waitlist fallback, and STOP ticking. Never renders negative time.
     • MutationObserver on `.glass-nav-announcement` so ticker clones picked
       up by dd-glass-nav.js initTicker() get ticked after harvest.
   ========================================================================== */
(function () {
  if (window._ddEventCountdownInit) return;
  window._ddEventCountdownInit = true;

  var REDUCED =
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var intervalId = null;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function mounts() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-dd-event-countdown]')
    );
  }

  function setNum(host, selector, value) {
    var el = host.querySelector(selector);
    if (el) el.textContent = value;
  }

  /* Renders one mount. Returns true when this mount is "done" (expired or
     mis-configured) so the caller can retire it from the tick loop. */
  function renderMount(host) {
    var targetStr = host.getAttribute('data-event-target');
    if (!targetStr) return true;

    var target = new Date(targetStr).getTime();
    if (isNaN(target)) return true;

    var diff = target - Date.now();
    var live = host.querySelector('[data-dd-ec-live]');
    var expired = host.querySelector('[data-dd-ec-expired]');

    if (diff <= 0) {
      if (live) live.hidden = true;
      if (expired) expired.hidden = false;
      host.setAttribute('data-dd-ec-state', 'expired');
      return true;
    }

    if (live) live.hidden = false;
    if (expired) expired.hidden = true;
    host.setAttribute('data-dd-ec-state', 'live');

    var totalSeconds = Math.floor(diff / 1000);
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    setNum(host, '[data-dd-ec-days]', String(days));
    setNum(host, '[data-dd-ec-hours]', pad(hours));
    setNum(host, '[data-dd-ec-minutes]', pad(minutes));
    setNum(host, '[data-dd-ec-seconds]', pad(seconds));
    return false;
  }

  function tickAll() {
    var list = mounts();
    var allDone = true;
    for (var i = 0; i < list.length; i++) {
      if (!renderMount(list[i])) allDone = false;
    }
    if (allDone && intervalId) {
      window.clearInterval(intervalId);
      intervalId = null;
    }
    return allDone;
  }

  function ensureInterval() {
    if (REDUCED || intervalId) return;
    var allDone = tickAll();
    if (allDone) return;
    intervalId = window.setInterval(tickAll, 1000);
  }

  function hasNewEventCountdownRoot(records) {
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      if (!added || !added.length) continue;
      for (var n = 0; n < added.length; n++) {
        var node = added[n];
        if (node.nodeType !== 1) continue;
        if (node.hasAttribute && node.hasAttribute('data-dd-event-countdown')) return true;
        if (node.querySelector && node.querySelector('[data-dd-event-countdown]')) return true;
      }
    }
    return false;
  }

  function attachObserver() {
    var tickerEls = document.querySelectorAll('.glass-nav-announcement');
    for (var t = 0; t < tickerEls.length; t++) {
      var tickerEl = tickerEls[t];
      if (!tickerEl || tickerEl._ddEventCountdownObserver) continue;
      try {
        var obs = new MutationObserver(function (records) {
          if (!hasNewEventCountdownRoot(records)) return;
          window.setTimeout(function () {
            ensureInterval();
          }, 50);
        });
        obs.observe(tickerEl, { childList: true, subtree: true });
        tickerEl._ddEventCountdownObserver = obs;
      } catch (e) { /* observer unsupported */ }
    }
  }

  function start() {
    if (!mounts().length) {
      attachObserver();
      return;
    }

    tickAll();
    attachObserver();

    if (REDUCED) return;
    ensureInterval();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
